import { ApolloClient } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { GetAngxStockSnapshotQuery, GetAngxStockSnapshotQueryVariables } from '@/types/codegen-federation'
import { GET_ANGX_STOCK_SNAPSHOT } from './queries'

/**
 * Hook to retrieve the latest ANGX stock snapshot.
 * Automatically polls every 15 minutes by default (as per product requirement for the ticker).
 * Pass { pollIntervalMs: 0 } to disable polling or override with a different interval.
 */
export const useAngxStockSnapshot = (client: ApolloClient | undefined, options?: { pollIntervalMs?: number }) => {
  const pollInterval = options?.pollIntervalMs === undefined ? 15 * 60 * 1000 : options.pollIntervalMs // default 15 minutes
  const { data, loading, error } = useQuery<GetAngxStockSnapshotQuery, GetAngxStockSnapshotQueryVariables>(
    GET_ANGX_STOCK_SNAPSHOT,
    {
      client,
      errorPolicy: 'all',
      // Setting to undefined prevents apollo from starting the poller if explicitly 0
      pollInterval: pollInterval && pollInterval > 0 ? pollInterval : undefined,
    },
  )

  return {
    stockSnapshot: !loading ? data?.angxStockSnapshot : undefined,
    loading,
    error,
  }
}
